import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
const QualifiedEventItemsContainer = styled.ul `
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  list-style: none;
  padding: 0;
  margin: 0;
  row-gap: 8px;

  @media ${query.lessThanSmall} {
    row-gap: 16px;
  }
`;
export default QualifiedEventItemsContainer;
